import React from "react";
import { IShardClusterRequestParams, IShardClusterListItem, ShardClusterSortField } from "api/entities/shard-cluster";
import { useNavigate } from "react-router-dom";
import { routeUtils } from "../../../utils/route-utils";
import Table, { IColumnDefinition, TableSelected } from "../../shared-ui/table/table";
import tableStyles from "../../shared-ui/table/table.module.scss";
import { MoreOption } from "./moreoption";
import styles from "./shard-cluster-table.module.scss";
import { IPage } from "api/entities/page";

interface IShardClusterTableProps {
    isLoading: boolean;
    page: IPage<IShardClusterListItem>;
    requestParams: IShardClusterRequestParams;
    setRequestParams: (data: Partial<IShardClusterRequestParams>) => void;

    selection?: TableSelected<IShardClusterListItem>;
    onSelectionChanged?: (selection: TableSelected<IShardClusterListItem>) => void;
    onSelectAll?: () => void;

    isRowClickable?: boolean;
    hasManageColumn?: boolean;
}

export function ShardClusterTable(props: IShardClusterTableProps) {
    const navigate = useNavigate();

    const columns: IColumnDefinition<IShardClusterListItem, ShardClusterSortField>[] = [
        {
            label: "Name",
            className: styles["col--name"],
            formatter: row => row.name,
            sortKey: ShardClusterSortField.Name
        },
        {
            label: "Air Gap",
            className: styles["col--air-gap"],
            formatter: _ => "Enabled",
        },
        {
            label: "Immutability",
            className: styles["col--immutability"],
            formatter: _ => "Transparently Enabled",
        },
    ];

    if (props.hasManageColumn) {
        columns.push(
            {
                label: "Manage",
                className: tableStyles["col--manage"],
                formatter: row => (<MoreOption data={row}/>),
            });
    }


    return (
        <Table
            testId="storage-pool-table"
            hideCheckbox={!props.selection}
            columns={columns}
            rows={props.page.data}
            totalRows={props.page.count}
            loading={props.isLoading}
            requestParams={props.requestParams}
            onRequestParamsChanged={props.setRequestParams}
            onRowClick={row => !!props.isRowClickable && navigate(routeUtils.getRouteToShardClusterDetails(row.id))}
            responsive={true}

            selected={props.selection}
            onSetSelected={props.onSelectionChanged}
            onSelectAll={props.onSelectAll}

        />
    );
}
